export const FloorGuideType = {
    MARKER: 'marker',
    DIRECTION: 'direction',
    DIRECTION_FROM_PARKING: 'direction_from_parking',
} as const;

export type FloorGuideType = (typeof FloorGuideType)[keyof typeof FloorGuideType];

export enum CategoryType {
    BABY_LOUNGE = 'BABY_LOUNGE',
    CUSTOMER_SERVICE_CENTER = 'CUSTOMER_SERVICE_CENTER',
    ELEVATOR = 'ELEVATOR',
    ESCALATOR = 'ESCALATOR',
    EXCHANGE = 'EXCHANGE',
    GIFT_REDEMPTION = 'GIFT_REDEMPTION',
    INFORMATION = 'INFORMATION',
    LOCKER = 'LOCKER',
    RESTROOM = 'RESTROOM',
    STROLLER_RENTAL = 'STROLLER_RENTAL',
    TAX_REFUND = 'TAX_REFUND',
}

export enum EASE_TYPE {
    EASE_IN = 'ease-in',
    LINEAR = 'linear',
}

export enum NavigationStatus {
    IDLE = 'IDLE',
    RUNNING = 'RUNNING',
    PAUSED = 'PAUSED',
    DONE = 'DONE',
}

export enum PoiType {
    FACILITY = 'FACILITY',
    SHOP = 'SHOP',
    FNB = 'FNB',
    CONTENT = 'CONTENT',
    NO_CONTENT = 'NO_CONTENT',
}
